import { Box, Pagination, useTheme } from "@mui/material";

interface PaginacaoPadraoProps {
  paginaAtual: number;
  totalPaginas: number;
  setPaginaAtual: (pagina: number) => void;
}

// Paginação padrão das listagens (mesmo padrão do XC WMS)
const PaginacaoPadrao = ({ paginaAtual, totalPaginas, setPaginaAtual }: PaginacaoPadraoProps) => {
  const theme = useTheme();

  return (
    <Box display="flex" justifyContent="center" mt={1} mb={2}>
      <Pagination
        count={totalPaginas}
        page={paginaAtual}
        onChange={(_event, value: number) => setPaginaAtual(value)}
        variant="outlined"
        shape="rounded"
        sx={{
          "& .Mui-selected": {
            backgroundColor: "#ffa226 !important",
            color: theme.palette.common.white,
          },
          "& .MuiPaginationItem-root:hover": {
            backgroundColor: theme.palette.warning.light,
          },
        }}
      />
    </Box>
  );
};

export default PaginacaoPadrao;
